import { ChangeEvent, useState } from 'react';
import { toast } from 'sonner';

interface LengthInputProps {
  value: number | undefined;
  editable: boolean;
  onChange: (value: number | undefined) => void;
}

export const LengthInput = ({
  value,
  editable,
  onChange,
}: LengthInputProps) => {
  const [inputValue, setInputValue] = useState(value?.toString() || '1');

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setInputValue(val);

    const numValue = parseInt(val, 10);

    // Validation: allow 1+ or -1, disallow 0 and negatives except -1
    if (isNaN(numValue)) {
      onChange(undefined);
    } else if (numValue === -1 || numValue > 0) {
      onChange(numValue);
    } else {
      // Invalid: don't update parent state
      toast.error('Length must be -1 (any) or positive');
    }
  };

  return (
    <div className="flex items-center gap-2">
      <label className="text-chariot-text-primary text-[10px] font-semibold">
        Length:
      </label>
      <input
        type="number"
        value={inputValue}
        onChange={handleChange}
        disabled={!editable}
        className="border-chariot-stroke w-20 rounded border px-2 py-1 text-[9px] disabled:cursor-not-allowed disabled:opacity-50"
        placeholder="1"
      />
      <span className="text-chariot-text-secondary text-[9px]">(-1 = any)</span>
    </div>
  );
};
